import React from 'react';
import styled from 'styled-components';
import { FaUndoAlt, FaSyncAlt, FaDoorOpen } from 'react-icons/fa';

const ActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 60px 0 40px; /* change this to add padding for buttons etc */
`;

const ActionButton = styled.button<{ $variant?: 'default' | 'negative' }>`
  width: 100px;
  height: 40px;
  border-radius: 5px;
  background: ${({ $variant }) =>
    $variant === 'negative'
      ? 'linear-gradient(180deg, rgba(255, 64, 0, 1), rgba(64, 16, 0, 1) 100%)'
      : 'linear-gradient(180deg, rgba(0, 127, 255, 1), rgba(0, 32, 64, 1) 100%)'};
  color: #fff;
  border: none;
  cursor: pointer;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 14px;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 0 10px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.15);

  /* glossy top + slight inner shadow for contrast */
  box-shadow:
    0px 0px 5px rgba(0,0,0,0.5),
    inset 0 1px 0 rgba(255,255,255,0.25),
    inset 0 -8px 12px rgba(0,0,0,0.35);

  svg {
    font-size: 18px;
    color: #fff;
    flex: 0 0 auto;
  }

  span {
    line-height: 1;
    text-shadow: 0 1px 0 rgba(0,0,0,0.6);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }
`;

interface GameActionsProps {
  onUndo: () => void;
  onRestart: () => void;
  onQuit: () => void;
  canUndo: boolean;
}

const GameActions: React.FC<GameActionsProps> = ({
  onUndo,
  onRestart,
  onQuit,
  canUndo,
}) => {
  return (
    <ActionsContainer>
      <ActionButton onClick={onUndo} disabled={canUndo}>
        <FaUndoAlt />
        <span>Undo</span>
      </ActionButton>

      <ActionButton onClick={onRestart}>
        <FaSyncAlt />
        <span>Restart</span>
      </ActionButton>

      <ActionButton onClick={onQuit} $variant="negative">
        <FaDoorOpen />
        <span>Quit</span>
      </ActionButton>
    </ActionsContainer>
  );
};

export default GameActions;